import { getCookie, setCookie, getQueryVariable } from "tpm-utils";

//applies correct promos & updates page content in products-cards.php
class PromoApplicator {
	constructor() {
		/* make sure the cards are here & user isn't a member */
		const el = document.querySelector(".PrimeProducts2");
		if (!el) return;
		if (el.classList.contains("--is-member")) return;
	}
}

const instance = new PromoApplicator();
window.tpm_promoapplicator = instance;
